import React from 'react';
import ModelingHub from './modeling/ModelingHub';

export function Modeling() {
  return <ModelingHub language="ru" />;
}

export default Modeling;
